export default __webpack_public_path__ + "static/why-tecalis_team-5c0e618c1c9a2eb9bafb532224cdccc4.png";